(function () {
    'use strict';

    function makeUrl() {
        return function (value) {
            var returnString = value;
            if (!/^https?:\/\//i.test(value)) {
                returnString = 'http://' + value;
            }

            return returnString;
        };
    }

    angular.module('ecap.common').filter('makeUrl', makeUrl);
})();